import React, { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form';
import PageWrapper from '@components/UI/PageWrapper/Index.jsx';
import ComplianceSectionCreateSolicitacao from '@components/Solicitacao/Admin/Create/Sections/ComplianceSection/Index';
import CreateSection from '@components/Solicitacao/Admin/Create/Sections/CreateSection/Index';
import ItensProcessoSection from '@components/Solicitacao/Admin/Create/Sections/ItensProcessoSection/Index';
import ButtonActions from '@components/Solicitacao/Admin/Create/Sections/ButtonActions/Index';

const CriarSolicitacao = () => {
  const [complianceData, setComplianceData] = useState({
    codigoCompliance: '',
    selectedRow: null,
    idProcesso: "",
    nomeProcesso: "",
    etapaProcesso: "",
  });

  const [solicitacaoProcessoItems, setSolicitacaoProcessoItems] = useState([]);

  const methods = useForm({
    defaultValues: {
      idTemplateEmailComunicado: null,
      idTemplateEmailSolicitacao: null,
      siglaUnidadeGerencia: "",
      nomeGerente: "",
      nomeEncarregado: "",
      emailCC: null,
      observacoes: null,
      prazoSolicitacao: "",
      dataLimiteSolicitacao: "",
      dataAgendarEnvio: null,
      statusSolicitacao: "",
      solicitacaoProcessoItems: [],
    },
  });

  return (
    <PageWrapper>
      <FormProvider {...methods}>

        {/* Compliance Associado a Solicitação */}
        <ComplianceSectionCreateSolicitacao
          methods={methods}
          complianceData={complianceData}
          setComplianceData={setComplianceData}
        />

        {/* Campos de Criação da Solicitação */}
        <CreateSection
          selectedRow={complianceData.selectedRow}
        />

        {/* Tabela com os itens do processo */}
        <ItensProcessoSection
          idProcesso={complianceData.idProcesso}
          etapaProcesso={complianceData.etapaProcesso}
          setSolicitacaoProcessoItems={setSolicitacaoProcessoItems}
        />

        {/* Botão para salvar a Solicitação */}
        <ButtonActions
          selectedRow={complianceData.selectedRow}
          solicitacaoProcessoItems={solicitacaoProcessoItems}
          methods={methods}
          setCodigoCompliance={value => setComplianceData(data => ({ ...data, codigoCompliance: value }))}
          setSolicitacaoProcessoItems={setSolicitacaoProcessoItems}
          setSelectedRow={value => setComplianceData(data => ({ ...data, selectedRow: value }))}
        />

      </FormProvider>
    </PageWrapper>
  );
};

export default CriarSolicitacao;